module.exports = __webpack_public_path__ + "img/class-work.5edb99d4.png";